module.exports = __webpack_public_path__ + "img/logo-issue-tracker--reversed.c1e27084.svg";